import { isProductionLikeEnvironment } from '../utils/runtime-environment'

export const pushDataLayerEvent = (
  event,
  eventCategory,
  eventAction,
  eventLabel
) => {
  if (!isProductionLikeEnvironment) return null

  try {
    window.dataLayer.push({
      event,
      eventCategory,
      eventAction,
      eventLabel
    })
  } catch (err) {
    console.error(err)
  }
}
